/**
 * O nome da automação, pedido no primeiro "Salvar" (26/10).
 *
 * A automação nasce sem nome ("Automação sem nome" na lista), e o nome só se
 * dava depois, pelo "Renomear" da lista, que quase ninguém achava. No primeiro
 * salvar, este diálogo pede o nome e a descrição, no centro da tela; o nome é
 * gravado antes do mapa (`PATCH .../nome-e-descricao`, que não cria versão).
 */

import { useState, type FormEvent, type ReactNode } from 'react';
import { Botao, Campo, CampoArea, Dialogo } from '@/shared/ui';
import { Faixa } from '@/shared/ui/estados/faixa';

export function NomearAutomacao({
  salvando,
  erro,
  aoConfirmar,
  aoFechar,
}: {
  salvando: boolean;
  /** O recado do que deu errado ao gravar o nome ou o mapa. */
  erro: string | null;
  aoConfirmar: (nome: string, descricao: string) => void;
  aoFechar: () => void;
}): ReactNode {
  const [nome, definirNome] = useState('');
  const [descricao, definirDescricao] = useState('');
  const [tentou, definirTentou] = useState(false);
  const erroNome = tentou && !nome.trim() ? 'Dê um nome para a automação.' : undefined;

  const enviar = (e: FormEvent): void => {
    e.preventDefault();
    definirTentou(true);
    if (!nome.trim() || salvando) return;
    aoConfirmar(nome.trim(), descricao.trim());
  };

  return (
    <Dialogo
      titulo="Dê um nome à automação"
      largura="estreita"
      aoFechar={() => {
        if (!salvando) aoFechar();
      }}
      botoes={
        <>
          <Botao variante="fantasma" onClick={aoFechar} desabilitado={salvando} motivo="Salvando…">
            Cancelar
          </Botao>
          <Botao
            type="submit"
            form="nomear-automacao"
            variante="primario"
            desabilitado={salvando}
            motivo="Salvando…"
          >
            {salvando ? 'Salvando…' : 'Salvar'}
          </Botao>
        </>
      }
    >
      <form id="nomear-automacao" className="editor-do-mapa__condicao" onSubmit={enviar} noValidate>
        <p className="editor-do-mapa__painel-ajuda">
          É o nome que a equipe vê na lista das automações. Dá para mudar depois, em “Renomear”.
        </p>
        <Campo
          rotulo="Nome"
          maxLength={120}
          placeholder="Ex.: Boas-vindas no WhatsApp"
          value={nome}
          onChange={(e) => definirNome(e.target.value)}
          {...(erroNome ? { erro: erroNome } : {})}
        />
        <CampoArea
          rotulo="Descrição (opcional)"
          rows={3}
          maxLength={500}
          placeholder="O que ela faz, em uma frase"
          value={descricao}
          onChange={(e) => definirDescricao(e.target.value)}
        />
        {erro && <Faixa tom="bloqueado">{erro}</Faixa>}
      </form>
    </Dialogo>
  );
}
